import { isMobile } from 'react-device-detect';
import { FC } from 'react';

import Mobile from './mobile';
import PC from './pc';
import { CollapseProps } from './interface';


const index: FC<CollapseProps> = (props) => {
	return isMobile ? <Mobile {...props} /> : <PC {...props} />;
};
export default index;
